import MemberCardVue from '@/views/member/card/card.vue';

const basePath = '/member/card';
const role = 'member'; // 角色身份

export const M_SIGN_IN_INDEX = 'm-card-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberCardVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_SIGN_IN_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "card" */
        `@/views/${role}/card/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
